exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .text {\n  padding-top: 7px;\n  text-align: left; }\n\n:host .link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #1A3476; }\n\n:host .slide-in-modal .label, :host .slide-in-modal .text {\n  display: inline-block;\n  text-align: left; }\n\n:host .slide-in-modal .label {\n  width: 25%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/text-only/text-only.component.scss
// module id = ../../../../../src/app/modules/ui-form/components/text-only/text-only.component.scss
// module chunks = main